// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2nfTM","tabsBox":"styles_tabsBox__2zkcZ","createButton":"styles_createButton__feZDn"};